// extracted by mini-css-extract-plugin
export default {"checkbox":"HomePopUp_checkbox__BtSy5","popUpContainer":"HomePopUp_popUpContainer__OtiJw"};